import { createFileRoute, redirect } from "@tanstack/react-router";

/** Moved under People Hub (NAU-424); kept so old links still land. */
export const Route = createFileRoute(
  "/_authenticated/settings/staff/$id/login-attempts",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/people/$userId/login-history",
      params: { userId: params.id },
    });
  },
});
